import { jwtDecode } from "jwt-decode";
import { fetchAuthSession } from "aws-amplify/auth";

export function getCurrentUserId(): string | null {
  const token = localStorage.getItem("idToken");
  if (!token) return null;
  try {
    const decoded: any = jwtDecode(token);
    return decoded.sub; // Cognito userId
  } catch {
    return null;
  }
}

export async function getAuthHeaders() {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    return {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  } catch (err) {
    console.error("Failed to get auth session:", err);
    return { "Content-Type": "application/json" };
  }
}

